import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MapPin } from "lucide-react";
import {
  DetailsPanel,
  DetailsPanelField,
} from "components/common/DetailsPanel";
import { getObjectStatusColor } from "./utils";
import { ObjectDetailsPanelProps } from "./types";

export const ObjectDetailsPanel = ({
  id,
  type,
  status,
  position,
  chessboardId,
  onSelectObject,
  onClose,
}: ObjectDetailsPanelProps) => {
  const { t } = useTranslation();

  const statusColor = useMemo(
    () =>
      getObjectStatusColor({
        status,
        isActive: false,
      }),
    [status],
  );

  const handleSelectObject = useCallback(() => {
    if (onSelectObject) {
      onSelectObject(id);
    }
  }, [onSelectObject, id]);

  return (
    <DetailsPanel
      open
      title={type}
      onClose={onClose}
      className="absolute top-4 left-4 z-10 w-60"
      footer={
        <button
          type="button"
          onClick={handleSelectObject}
          className="inline-flex w-full items-center justify-center gap-2 rounded-md
                     bg-blue-600 px-3 py-2 text-sm font-medium text-white
                     hover:bg-blue-700 focus-visible:outline-none
                     focus-visible:ring-2 focus-visible:ring-blue-500/30"
        >
          <MapPin className="h-4 w-4" />
          {t("doc_viewer.viewOnPlan")}
        </button>
      }
    >
      <DetailsPanelField label="Status">
        <span
          className="inline-flex rounded-full px-3 py-1 text-sm font-medium"
          style={{ backgroundColor: statusColor, color: "white" }}
        >
          {t(
            status === "installed"
              ? "doc_viewer.object_status_installed"
              : "doc_viewer.object_status_not_installed",
          )}
        </span>
      </DetailsPanelField>
      <DetailsPanelField label="Position">
        <span className="tabular-nums">
          X: {position.x}, Y: {position.y}
        </span>
      </DetailsPanelField>
      <DetailsPanelField label="Grid Position">
        <span className="font-mono">{chessboardId}</span>
      </DetailsPanelField>
    </DetailsPanel>
  );
};
